export function openPopup(popupUrl) {
    window.open(popupUrl, 'popup', 'popup=true,width=400,height=500');
}
// Captures 0x + 4 characters, then the last 4 characters.
const truncateRegex = /^(0x[a-zA-Z0-9]{4})[a-zA-Z0-9]+([a-zA-Z0-9]{4})$/;
export const truncateEthAddress = (address) => {
    const match = address.match(truncateRegex);
    if (!match)
        return address;
    return `${match[1]}…${match[2]}`;
};
export const STORAGE_PREFIX = '@CAPSULE/';
export const emptyFunction = () => { };
